<template>
  <div class="line-input">
    <a-input-password
      v-if="isPassword"
      v-model:value="inputValue"
      :style="'width:' + width"
      :placeholder="placeholder"
      :visibilityToggle="visibilityToggle"
      :maxLength="maxLength"
    ></a-input-password>
    <a-input
      v-else
      v-model:value="inputValue"
      :style="'width:' + width"
      :placeholder="placeholder"
      :maxLength="maxLength"
    >
    </a-input>

    <span
      :class="{
        code: true,
        'code-enable': countdown === countdownTime,
        'code-disable': countdown !== countdownTime,
      }"
      v-if="isVerifyCode"
      @click="handleGetVerifyCode"
    >
      {{ countdown === countdownTime ? 'Get Code' : countdown + ' s' }}
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LineInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '100%',
    },
    visibilityToggle: {
      type: Boolean,
      default: false,
    },
    isPassword: {
      type: Boolean,
      default: false,
    },
    isVerifyCode: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 80,
    },
  },
  data() {
    return {
      isCountingDown: false,
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      },
    },
    ...mapState({
      countdown: (state) => state.base.countdown,
      countdownTime: (state) => state.base.countdownTime,
    }),
  },
  methods: {
    handleGetVerifyCode() {
      this.$emit('get-code')
    },
  },
}
</script>

<style lang="scss">
.line-input {
  position: relative;

  .code {
    position: absolute;
    width: 100px;
    text-align: center;
    top: 50%;
    transform: translate(0, -50%);
    right: 10px;
    user-select: none;
  }
  .code-enable {
    cursor: pointer;
    color: #0080ff;
    &:hover {
      color: #66ccff;
    }
  }
  .code-disable {
    cursor: not-allowed;
    color: #999;
  }

  .ant-input,
  .ant-input-password,
  .ant-input-affix-wrapper {
    border-left: 0;
    border-right: 0;
    border-top: 0;

    &:focus {
      border-left: 0;
      border-right: 0;
      border-top: 0;
      box-shadow: none;
    }
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
  }

  // .ant-input-group-wrapper {
  //   .ant-input-group {
  //     .ant-input-group-addon {
  //       border: none;
  //     }
  //   }
  // }
}
</style>
